module.exports = __webpack_public_path__ + "img/yj.6a13b183.png";